module.exports = {"id":"181402","name":"William Vainqueur","rating":"77","photo":"./data/images/photos/3/181402.png","club":{"name":"Antalyaspor","logo":"./data/images/clubs/Antalyaspor.png"},"positions":["MDC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/WilliamVainqueur0.json
// module id = 4350
// module chunks = 0